(function () {
    'use strict';

    angular.module("imApp").factory("poWorksService", ['$ihttp', function ($ihttp) {
        var service = {
            getPoWorks: function (parms) {
                return $ihttp.post({
                    method: 2593,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();